module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201112_298.fa8aa5a4.jpg";